import React from 'react';
import { motion } from 'framer-motion';
import { Star, Check, ShieldCheck } from 'lucide-react';
import { Button } from '../ui/Button';
export function Hero() {
  return <section className="relative bg-[#020617] overflow-hidden" data-id="element-38">
      {/* Top Trust Bar */}
      <div className="bg-[#1c2738] text-white text-base md:text-lg py-3 text-center font-medium tracking-wide" data-id="element-39">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6" data-id="element-40">
          <span data-id="element-41">TRUSTED BY OVER 47,000 MEN</span>
          <span className="hidden md:inline opacity-50" data-id="element-42">•</span>
          <span data-id="element-43">60-DAY GUARANTEE</span>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-10" data-id="element-44">
        {/* Logo / Brand */}
        <div className="mb-4 text-center md:text-left" data-id="element-45">
          <img src="https://cdn.magicpatterns.com/uploads/nUttpdeihiBngzAR3vZQgp/Flow_Regen_Favicon_(6).svg" alt="Flow Regen" className="h-8 md:h-10 inline-block" data-id="element-46" />
        </div>

        {/* Secondary Trust Badges - Hidden on mobile */}
        <div className="mb-8 hidden md:flex justify-center md:justify-end" data-id="element-47">
          <div className="inline-flex flex-col md:flex-row items-center gap-3 md:gap-4 text-base" data-id="element-48">
            <div className="inline-flex items-center space-x-2 bg-[#e6b500]/10 text-[#e6b500] px-3 py-1.5 rounded-full font-bold tracking-wider uppercase border border-[#e6b500]/20" data-id="element-49">
              <ShieldCheck className="w-3.5 h-3.5" data-id="element-50" />
              <span data-id="element-51">Clinically Inspired European Formula</span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-52">
          {/* Content Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-6" data-id="element-53">
            {/* Star Rating */}
            <div className="flex items-center space-x-2" data-id="element-54">
              <div className="flex text-yellow-400" data-id="element-55">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-56" />)}
              </div>
              <span className="text-slate-300 font-medium text-lg" data-id="element-57">4.8/5</span>
              <span className="text-slate-500" data-id="element-58">•</span>
              <span className="text-lg text-slate-400" data-id="element-59">2,800+ men</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" data-id="element-60">
              Finally Sleep Through The Night{' '}
              <span className="text-[#e6b500]" data-id="element-61">
                Without A Single Bathroom Trip
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-slate-300 leading-relaxed" data-id="element-62">
              The European "vein tonic" protocol that releases the{' '}
              <span className="font-semibold text-white" data-id="element-63">
                Pelvic Pressure Trap
              </span>{' '}
              — so your bladder stays calm until morning.
            </p>

            {/* Product Image - Mobile Only (between subheading and bullet points) */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.3
          }} className="lg:hidden relative" data-id="element-64">
              <div className="relative z-10 bg-slate-800/50 rounded-3xl shadow-2xl border border-slate-700 p-6 text-center overflow-hidden backdrop-blur-sm" data-id="element-65">
                <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#e6b500] to-emerald-500" data-id="element-66" />

                {/* Product Image */}
                <div className="mx-auto mb-6 flex items-center justify-center" data-id="element-67">
                  <img src="https://cdn.magicpatterns.com/uploads/9wyKbuZqLf3CM44f71wTyf/1.png" alt="Flow Regen Prostate Support Drops with Natural Ingredients" className="w-full h-auto rounded-xl" data-id="element-68" />
                </div>

                <div className="bg-slate-900/50 rounded-xl p-4 border border-slate-700" data-id="element-69">
                  <div className="flex items-center justify-center space-x-3 mb-2" data-id="element-70">
                    <div className="w-12 h-12 bg-slate-700 rounded-full overflow-hidden flex items-center justify-center" data-id="element-71">
                      <img src="https://cdn.magicpatterns.com/uploads/uJZxZztHk3u3yykFeNZRRy/2.png" alt="Dr. Blane Schilling, MD" className="w-full h-full object-cover" data-id="element-72" />
                    </div>
                    <div className="text-left" data-id="element-73">
                      <div className="font-bold text-white text-lg" data-id="element-74">
                        Dr. Blane Schilling, MD
                      </div>
                      <div className="text-base text-slate-400" data-id="element-75">
                        30+ Years Experience
                      </div>
                    </div>
                  </div>
                  <p className="text-lg text-slate-300 italic" data-id="element-76">
                    "I have never seen a natural solution work this effectively
                    for men's circulation and prostate comfort."
                  </p>
                </div>
              </div>

              {/* Decorative background blob */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[#e6b500]/10 rounded-full blur-3xl -z-10" data-id="element-77" />
            </motion.div>

            <ul className="space-y-4 pt-4" data-id="element-78">
              {['Sleep 6–8 hours uninterrupted — the pressure ring finally released.', 'End "false full" bladder signals — your brain stops screaming emergencies.', 'Support healthy pelvic circulation — the European approach GPs miss.', 'No prescriptions, no sexual side effects — 8 natural botanicals.', 'Feel the difference in 7–14 nights — or get every penny back.'].map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.2 + index * 0.1
            }} className="flex items-start space-x-3" data-id="element-79">
                  <div className="flex-shrink-0 mt-1" data-id="element-80">
                    <div className="bg-emerald-500/20 rounded-full p-1" data-id="element-81">
                      <Check className="w-4 h-4 text-emerald-400" data-id="element-82" />
                    </div>
                  </div>
                  <span className="text-slate-300 text-lg" data-id="element-83">{item}</span>
                </motion.li>)}
            </ul>

            <div className="pt-8 flex flex-col sm:flex-row gap-4" data-id="element-84">
              <Button size="lg" variant="primary" scrollTo="pricing" className="text-xl px-8 py-6 shadow-xl shadow-[#e6b500]/10 hover:shadow-[#e6b500]/20 transition-all" data-id="element-85">
                YES! I WANT TO SLEEP THROUGH THE NIGHT
              </Button>
            </div>
            <p className="text-lg text-slate-400 font-medium" data-id="element-86">
              Free shipping on 3+ bottles • 60-Day Money-Back Guarantee
            </p>
          </motion.div>

          {/* Image/Visual Column - Desktop Only */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="relative hidden lg:block" data-id="element-87">
            <div className="relative z-10 bg-slate-800/50 rounded-3xl shadow-2xl border border-slate-700 p-6 md:p-8 text-center overflow-hidden backdrop-blur-sm" data-id="element-88">
              <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#e6b500] to-emerald-500" data-id="element-89" />

              {/* Product Image - Larger */}
              <div className="mx-auto mb-6 flex items-center justify-center" data-id="element-90">
                <img src="https://cdn.magicpatterns.com/uploads/9wyKbuZqLf3CM44f71wTyf/1.png" alt="Flow Regen Prostate Support Drops with Natural Ingredients" className="w-full h-auto rounded-xl" data-id="element-91" />
              </div>

              <div className="bg-slate-900/50 rounded-xl p-4 border border-slate-700" data-id="element-92">
                <div className="flex items-center justify-center space-x-3 mb-2" data-id="element-93">
                  <div className="w-12 h-12 bg-slate-700 rounded-full overflow-hidden flex items-center justify-center" data-id="element-94">
                    <img src="https://cdn.magicpatterns.com/uploads/uJZxZztHk3u3yykFeNZRRy/2.png" alt="Dr. Blane Schilling, MD" className="w-full h-full object-cover" data-id="element-95" />
                  </div>
                  <div className="text-left" data-id="element-96">
                    <div className="font-bold text-white text-lg" data-id="element-97">
                      Dr. Blane Schilling, MD
                    </div>
                    <div className="text-base text-slate-400" data-id="element-98">
                      30+ Years Experience
                    </div>
                  </div>
                </div>
                <p className="text-lg text-slate-300 italic" data-id="element-99">
                  "I have never seen a natural solution work this effectively
                  for men's circulation and prostate comfort."
                </p>
              </div>
            </div>

            {/* Decorative background blob */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[#e6b500]/10 rounded-full blur-3xl -z-10" data-id="element-100" />
          </motion.div>
        </div>
      </div>
    </section>;
}